import { render, staticRenderFns } from "./AddProjectDialog.vue?vue&type=template&id=351eb43e&scoped=true&"
import script from "./AddProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./AddProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddProjectDialog.vue?vue&type=style&index=0&id=351eb43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351eb43e",
  null
  
)

export default component.exports